<div class="form-content">
  <crm-model-driven-form
    [objectType]="objectType"
    [existingObjectId]="crmObjectId$ | async"
    [submitButtonText]="'ACTIONS.SAVE' | translate"
    [cancelButtonText]="'ACTIONS.CANCEL' | translate"
    [loadingStatus]="loadingStatus()"
    [savingStatus]="savingStatus$$ | async"
    [fieldConfig]="fieldConfig$ | async"
    [readOnly]="false"
    [mode]="'panel'"
    [objectSubtype]="crmObject.crmObjectSubtype"
  ></crm-model-driven-form>
</div>
